module.exports = __webpack_public_path__ + "static/img/JT.370a373.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/JT.png
// module id = fsLJ
// module chunks = 34